<template>

	<v-container :class='$vuetify.breakpoint.mdAndDown ? "pa-0" : "pa-0 px-1"' fluid>
		<!-- Fix- or Flex-Durationfilter -->
		<v-container>
			<v-row>
				<v-col
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='text-center'
					:cols='$vuetify.breakpoint.xsOnly ? 12 : 12'
					md='4'
				>

					<v-btn
						:depressed='isSelectedDuration(default_option_fixed)'
						:outlined='!isSelectedDuration(default_option_fixed)'
						block
						class='select_btn light-border br-3'
						color='primary'
						@click='optionDurationClicked(default_option_fixed)'
					>
						{{ default_duration }}
					</v-btn>
				</v-col>

				<v-col
					v-for='option in duration_options'
					:key='option.value'
					:cols='filter.two_lines_mobile ? 12 : 12'
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='text-center'
					md='4'
				>
					<v-btn
						:depressed='isSelectedDuration(option)'
						:outlined='!isSelectedDuration(option)'
						block
						:small='$vuetify.breakpoint.mdAndDown'
						class='select_btn light-border br-3'
						color='primary'
						@click='optionDurationClicked(option)'
					>
						<div class='text-ellipsis' style='max-width: 100%'>
							{{ option.label }}
						</div>
					</v-btn>
				</v-col>

				<v-col
					cols='12'
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='fixed-duration-info d-inline-flex'
				>
					<i class='far fa-info-circle' />
					<p> {{ duration_description }} </p>
				</v-col>
			</v-row>
		</v-container>
		<!-- Slider -->
		<v-container :class='$vuetify.breakpoint.mdAndDown ? "pa-0" : "pa-0 px-1"' fluid>
			<v-row v-if='standalone_default_option' no-gutters style='width: 100%; margin-bottom: 10px'>
				<v-col
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='text-center'
					cols='12'
					md='4'
				>
					<v-btn
						:depressed='isSelected(default_option)'
						:outlined='!isSelected(default_option)'
						block
						class='select_btn light-border br-3'
						color='primary'
						@click='optionClicked(default_option)'
					>
						{{ default_option.label }}
					</v-btn>

				</v-col>
				<v-col
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='d-flex justify-end text-right'
					cols='6'
					md='4'
				/>
			</v-row>

			<v-row align='center' align-content='center' no-gutters>
				<v-col
					v-for='option in options'
					:key='option.id'
					:cols='filter.two_lines_mobile ? 6 : 12'
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='text-center'
					md='4'
				>
					<v-btn
						:depressed='isSelected(option)'
						:outlined='!isSelected(option)'
						block
						:small='$vuetify.breakpoint.mdAndDown'
						class='select_btn light-border br-3'
						color='primary'
						@click='optionClicked(option)'
					>
						<div class='text-ellipsis' style='max-width: 100%'>
							{{ addUnitToLabel(filter, option.label) }}
						</div>
					</v-btn>
				</v-col>
			</v-row>

		</v-container>
	</v-container>
</template>

<script>
import BaseFilterMixin from './BaseFilterMixin'
import 'vue-slider-component/theme/default.css'
import utils from '@/libs/utils';

export default {
	name: 'DurationFilter',
	components: {},
	mixins: [BaseFilterMixin],

	data() {
		const value = this.filter.values.find(f => f.default)
		return {
			standalone_default_option: false,
			default_option_fixed: undefined,
			selected_options: [],
			default_option: undefined,
      selected_duration_options: [],
			selected: [],
			savedFilters: [],
			default_duration: value.default_duration,
			duration_description: value.duration_description,
      duration_options: []
		}
	},

	computed: {
		options() {
			if (!this.standalone_default_option) return this.filter.values

			const options = []
			for (let option of this.filter.values) {
				if (!option.default) {
					options.push(option) // remove default option from other options, if the default is standalone
				}
			}

			return options
		}
	},

	mounted() {
    const default_option_fixed = this.filter.duration_options.find((o) => o.default);
    this.duration_options = this.filter.duration_options.filter(i => !i.default);
    const default_slider_option = this.filter.values.find((o) => o.default);

    if (!default_option_fixed) {
      console.warn('default option not specified for:', this.filter)
    }
    this.default_option_fixed = default_option_fixed
    this.selected_duration_options = [default_option_fixed]
    this.selected_options = [default_slider_option];
    this.default_option = default_slider_option;
    this.standalone_default_option = true;
    if(this.filter.selectedValues) {
      this.selected_duration_options = [this.filter.selectedValues[0]]
      this.selected_options = [this.filter.selectedValues[1]]
    }

	},

	methods: {
		isSelected(elem) {
			return this.selected_options.filter(e => {
			  return e.value == elem.value
      }).length > 0
		},
    isSelectedDuration(elem) {
      return this.selected_duration_options.filter(e => {
        return e.value == elem.value
      }).length > 0
    },
		addUnitToLabel(filter, label) {
			return utils.addUnitToLabel(filter, label)
		},

		optionClicked(option) {
      this.selected_options = [option]
      this.updateFilter([this.selected_duration_options[0], this.selected_options[0]]);

    },

    optionDurationClicked(option) {
      this.selected_duration_options = [option]

      this.updateFilter([this.selected_duration_options[0], this.selected_options[0]]);

    },

	}
}
</script>


<style>
.round-slider-container span.rs-number, .round-slider-container span.rs-default {
	position: absolute;
	top: -10px;
	left: -34px;
	font-size: 15px;
	font-weight: bold;
	z-index: 0;
}

.round-slider-container span.rs-default {
	top: -9px;
	left: -64px;
}

.round-slider-container span.rs-tooltip.rs-tooltip-text {
	font-size: 15px !important;
	word-break: break-word;
	overflow-wrap: break-word;
	padding: 0 20px;
	margin-top: 0 !important;
	margin-left: 0 !important;
	top: 38% !important;
	left: 0 !important;
	width: 100% !important;
	transform: translate(0, 0) !important;
}

</style>

<style scoped>
.slider-container svg {
	transform: rotate(270deg);
}

.explanation {
	font-weight: 600;
	margin-top: 19px;
	min-height: 39px;
}
.vue-slider {
	box-sizing: content-box !important;
}

.vue-slider *{
	box-sizing: inherit !important;
}

.fixed-duration-info {
	font-size: 12px;
}

.fixed-duration-info .fa-info-circle {
	padding: 3px 5px 0px 0px;
}

</style>